// extracted by mini-css-extract-plugin
export default {"theme":"#1890ff"};